import type { FeedbackData } from '../types';
export interface FeedbackRepository {
    feedback<T>(data: FeedbackData<T>): Promise<boolean>;
}

export const FeedbackRepository = Symbol('FeedbackRepository');
